
import { useState, useEffect, useRef } from 'react';

export default function Training() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const trainings = [
    {
      institution: 'Erudit Formation & Consulting',
      period: 'Du 01/09/2019 au 15/03/2020',
      courses: [
        { name: 'Gestion des resources humaines', percentage: 75, certificate: 'https://justenjay1234.github.io/fouedieua/gestionress.pdf' },
        { name: 'Initiation à la comptabilité générale', percentage: 55, certificate: 'https://justenjay1234.github.io/fouedieua/comptagene.pdf' },
        { name: 'Fiscalité des entreprises', percentage: 40, certificate: 'https://justenjay1234.github.io/fouedieua/fisca.pdf' },
        { name: 'Informatique bureautique', percentage: 90, certificate: 'https://justenjay1234.github.io/fouedieua/infobureau.pdf' },
        { name: 'Création et management des entreprises', percentage: 65, certificate: 'https://justenjay1234.github.io/fouedieua/management.pdf' },
        { name: 'Secrétariat et assistance administrative', percentage: 80, certificate: 'https://justenjay1234.github.io/fouedieua/secre.pdf' },
      ],
    },
    {
      institution: 'Centre Media Formation',
      period: '2021 / 2022',
      courses: [
        { name: 'Marketing Digital', percentage: 80, certificate: 'https://justenjay1234.github.io/fouedieua/img/digital.pdf' },
        { name: 'Adobe Illustrateur', percentage: 45, certificate: 'https://justenjay1234.github.io/fouedieua/img/compta.pdf' },
        { name: 'Adobe Premiere Pro', percentage: 65, certificate: 'https://justenjay1234.github.io/fouedieua/img/compta.pdf' },
        { name: 'Adobe Photoshop', percentage: 35, certificate: 'https://justenjay1234.github.io/fouedieua/img/elaboration.pdf' },
      ],
    },
    {
      institution: 'Attestation En Présentiel',
      period: '2023 / 2024',
      courses: [
        { name: 'Digital Marketing', percentage: 80, certificate: 'https://justenjay1234.github.io/fouedieua/img/digital.pdf' },
        { name: "Comprendre L'Entreprise", percentage: 55, certificate: 'https://justenjay1234.github.io/fouedieua/img/elaboration.pdf' },
      ],
    },
    {
      institution: 'Autres formations en ligne',
      period: '',
      courses: [
        { name: 'Marketing digital (OpenClassrooms)', percentage: 75, certificate: 'https://justenjay1234.github.io/fouedieua/img/digital.pdf' },
        { name: 'Comptabilité (OpenClassrooms)', percentage: 45, certificate: 'https://justenjay1234.github.io/fouedieua/img/compta.pdf' },
        { name: "Elaboration d'une campagne publicitaire (OpenClassrooms)", percentage: 80, certificate: 'https://justenjay1234.github.io/fouedieua/img/elaboration.pdf' },
      ],
    },
  ];

  const getColorClass = (percentage: number) => {
    if (percentage >= 80) return 'bg-green-500';
    if (percentage >= 60) return 'bg-blue-500';
    if (percentage >= 40) return 'bg-yellow-500';
    return 'bg-orange-500';
  };

  return (
    <section id="training" className="py-20 bg-gray-50" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
          Formations
        </h2>

        <div className="space-y-16 max-w-3xl mx-auto">
          {trainings.map((training, idx) => (
            <div key={idx} className="space-y-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {training.institution}
                </h3>
                {training.period && (
                  <p className="text-gray-600">{training.period}</p>
                )}
              </div>

              <div className="space-y-6">
                {training.courses.map((course, index) => (
                  <div key={index} className="space-y-2">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex items-start gap-3 flex-1">
                        <div className={`w-10 h-10 flex items-center justify-center ${getColorClass(course.percentage)} text-white rounded-lg flex-shrink-0 mt-1`}>
                          <i className="ri-graduation-cap-fill text-xl"></i>
                        </div>
                        <div className="flex-1">
                          <span className="font-semibold text-gray-900 block">{course.name}</span>
                          <a
                            href={course.certificate}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-700 text-sm inline-flex items-center gap-1 mt-1 cursor-pointer whitespace-nowrap"
                          >
                            Voici Le Certificat
                            <i className="ri-external-link-line"></i>
                          </a>
                        </div>
                      </div>
                      <span className="font-bold text-gray-900 whitespace-nowrap">{course.percentage}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                      <div
                        className={`h-full ${getColorClass(course.percentage)} rounded-full transition-all duration-1000 ease-out relative overflow-hidden`}
                        style={{ width: isVisible ? `${course.percentage}%` : '0%' }}
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
